/**
 * If true, the coupon applies to ticket types only.
 */
export const checkIsTicketTypeCoupon = (coupon: any) => {
  if (coupon && coupon.ticketTypes && coupon.ticketTypes.length > 0) return true;

  return false;
};

/**
 * If true, the coupon applies to an entire order
 */
export const checkIsOrderCoupon = (coupon: any) => {
  if (!coupon) return false;
  if (checkIsTicketTypeCoupon(coupon)) return false;

  return true;
};
